import React from 'react';

import SetPasswordInstruction from './SetPasswordInstruction';
import { NewPasswordValidationType } from './UserPassword.component';

type SetPasswordInstructionsType = {
  passwordValidations: NewPasswordValidationType;
};

const SetPasswordInstructions = ({
  passwordValidations,
}: SetPasswordInstructionsType): JSX.Element => {
  return (
    <>
      <SetPasswordInstruction
        errorState={passwordValidations['length']}
        message="Passwords must be at least eight characters long."
      />
      <SetPasswordInstruction
        errorState={passwordValidations['upperCase']}
        message="Passwords must have an uppercase character."
      />
      <SetPasswordInstruction
        errorState={passwordValidations['lowerCase']}
        message="Passwords must have a lowercase character."
      />
      <SetPasswordInstruction
        errorState={passwordValidations['number']}
        message="Passwords must include a number."
      />
    </>
  );
};

export default SetPasswordInstructions;
